import gql from 'graphql-tag';
import { eventTimelineFragment } from './fragments';
import { simplePaginationFragment } from '../shared/paginationFragment';

export default gql`
  query eventTimelineByContext($filters: EventTimelineFiltersInput!) {
    eventTimelineByContext(filters: $filters) {
      collection {
        ...eventTimelineParts
      }
      pagination {
        ...simplePaginationParts
      }
    }
  }
  ${simplePaginationFragment}
  ${eventTimelineFragment}
`;
